export const specialtyConfig = {
  specialtyContactLenses: {
    label: 'Specialty Contact Lenses',
    type: 'checkbox',
  },
  myopiaControl: {
    label: 'Myopia Control',
    type: 'checkbox',
  },
  dryEyeProgram: {
    label: 'Dry Eye Program',
    type: 'checkbox',
  },
  visionTherapy: {
    label: 'Vision Therapy',
    type: 'checkbox',
  },
  generalMedicalEyecare: {
    label: 'General Medical Eyecare',
    type: 'checkbox',
  },
  iplTreatment: {
    label: 'IPL Treatment',
    type: 'checkbox',
  },
  tearCareTreatment: {
    label: 'TearCare Treatment',
    type: 'checkbox',
  },
  lipiflowTreatment: {
    label: 'Lipiflow Treatment',
    type: 'checkbox',
  },
  iluxTreatment: {
    label: 'iLux Treatment',
    type: 'checkbox',
  },
  lllt: {
    label: 'LLLT',
    type: 'checkbox',
  },
  rfTreatment: {
    label: 'RF Treatment',
    type: 'checkbox',
  },
  yagCapsulotomy: {
    label: 'YAG Capsulotomy',
    type: 'checkbox',
  },
  sltLaser: {
    label: 'SLT Laser',
    type: 'checkbox',
  },
};
